var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"small":"","text":""},on:{"click":_vm.downloadReport}},[_c('v-icon',[_vm._v("mdi-download")]),_vm._v(_vm._s(_vm.data.title || "Download " + _vm.data.format.toUpperCase())+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }